<dgx-components-progression-steps
  *ngIf="cs.vm$ | async as vm"
  [disableNavigation]="vm.disableNavigation"
  [simpleView]="true"
  [steps]="vm.progressionSteps"
/>
